import React, { useState, useEffect } from 'react'

import { legacyImageURL } from 'components/LegacyImage'
import PlaceHolderImage from 'components/PlaceholderImage'

import Dropdown from './Dropdown'

// this is shared on ReminderScreen and SubmitReviewScreen

const ProductOverview = ({ products, defaultProductId, onProductSelect }) => {
  // console.log("ProductOverview render")
  defaultProductId = defaultProductId ? defaultProductId : products[0].productId

  const [productId, setProductId] = useState(defaultProductId)

  useEffect(() => {
    setProductId(defaultProductId)
  }, [defaultProductId])

  let product = products.find(product => {
    return product.productId === productId
  })

  const selectorData = products.map(product => {
    return {
      id: product.productId,
      label: product.dropdownTitle,
    }
  })

  const handleProductSelect = (id, label) => {
    setProductId(id)
    onProductSelect && onProductSelect(id, label)
  }

  if (!product) {
    product = products[0]
  }

  return (
    <div className={`product-overview`}>
      <div className={`product-overview--selector`}>
        <Dropdown
          defaultLabel={`Select a product`}
          items={selectorData}
          onSelect={handleProductSelect}
          defaultItemId={productId}
        />
      </div>

      <div className="product">
        <div className="detail">
          <div className="image">
            {product.image && (
              <PlaceHolderImage
                src={legacyImageURL(product.image)}
                width={300}
                height={200}
              />
            )}
            {/*
                        4.5<br/>
                        stars<br/>
                        <StarRating rating={4.5} outOf={5} />
                        */}
          </div>
          <div
            className="copy"
            dangerouslySetInnerHTML={{ __html: product.description }}
          />
        </div>
      </div>
    </div>
  )
}

export default ProductOverview
